import type { FaireProductEntity } from "../../entity_types/product";

export const p_9tfcvjg964: FaireProductEntity = {
  token: "p_9tfcvjg964",
  type: "product",
  name: "Clear Quartz Sphere (1 kg/2.2 lbs pack)",
  brandToken: "b_raqzmc7tej",
  brandName: "AmazeU",
  imageUrl:
    "https://cdn.faire.com/fastly/1b07ab9f15f14e9710aaf58bb72eadb04edf275ae3d8e1bfe4a3c7e87130f086.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2c0beed052eca68f635146fadc5e7d2e385a645477a8b1615b2362b683604b65.jpeg",
  ],
  priceDollars: 67.9,
  description:
    'Clear Quartz Sphere\n\nMade from High Quality Clear Quartz Gemstone \n=========================\nPrice is for 1 Kg of Clear Quartz Sphere of mixed sizes\n- Size: 150 to 250 Grams, 40 to 50 mm  Diameter\n- 5 to 6 pcs in a Kg.\n- 1 kg/2.2 lbs pack\n=======================\nClear quartz, also known as rock crystal, is a versatile and widely used gemstone and crystal in the world of metaphysical and spiritual practices.\nMetaphysical Properties: Clear quartz is believed to have various metaphysical and healing properties, including the ability to amplify energy, clarity of thought, and the balancing of one\'s energy. It is often used as a "master healer" and can be programmed with intentions for various purposes.\n==========\nNote:\nSince this is hand-carved from Natural Gemstones, there may be black spots and difference in color, size, weight etc. The pictures also look larger in size...',
  tags: [],
  msrpDollars: 135.8,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:56:09.975Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
